import config from "../../../config/config";
import { snackActions } from '../../sc-utilities/SnackBar';
import moment from "moment";


const updateDownloadProgress = progress => {

    return {
        type: 'DOWNLOAD|DOWNLOAD_PROGRESS',
        downloadProgress: progress.downloadProgress,
        maxSize: progress.maxSize,
        currentSize: progress.currentSize,
        snackBar: progress.snackBar,
        data: progress,
        name: progress.name
    };
};

// Custom functions 
export const downloadFileTool = (ToolID, id, name) => {
    return async _dispatch => {
        try {
            let token = localStorage.getItem('SESSION');

            const objectURL = `${config.backend_domain}:${config.backend_port}/securaze-tools/download?SecurazeToolID=${ToolID}&ActiveCustomerID=${id}&Token=${token}`;
            const downloadElement = document.createElement('a');
            downloadElement.href = objectURL;
            downloadElement.target = '_blank';
            downloadElement.download = `${name}`;
            return downloadElement.click();
        } catch (error) {
        }

    }
}

export const downloadErasure = (erasureID, id, name, translations) => {
    let token = localStorage.getItem('SESSION');

    return async dispatch => {
        snackActions.snackBar({
            message: translations['download_start'] || `Download starting...`,
            options: {
                variant: 'info'
            }
        });

        return fetch(`${config.backend_domain}:${config.backend_port}/erasure_reports/download?EraseReportID=${erasureID}&ActiveCustomerID=${id}&Token=${token}`, {
            method: "GET",
        }).then(async response => {
            try {

                if (response.status === 200) {
                    const reader = response.body.getReader();
                    const contentLength = +response.headers.get('fileSize');
                    let receivedLength = 0;
                    let chunks = [];
                    while (true) {
                        const { done, value } = await reader.read();

                        if (done) {
                            break;
                        }
                        chunks.push(value);
                        receivedLength += value.length;

                        dispatch(updateDownloadProgress({ downloadProgress: Math.floor(receivedLength / contentLength * 100), maxSize: Math.floor(contentLength / 1048576), currentSize: Math.floor(receivedLength / 1048576), snackBar: contentLength / 1048576 === receivedLength / 1048576, name: name !== undefined ? name : moment(), ImageID: erasureID }));

                    }
                    snackActions.snackBar({
                        message: translations['download_success'] || `Download successful.`,
                        options: {
                            variant: 'success'
                        }
                    });
                    dispatch(updateDownloadProgress({ downloadProgress: 0, maxSize: 0, currentSize: 0, snackBar: false, name: name !== undefined ? name : moment(), ImageID: erasureID }));

                    return new Blob(chunks);
                }
                return null;
            } catch (error) {
                dispatch(updateDownloadProgress({ downloadProgress: 0, maxSize: 0, currentSize: 0, snackBar: false, name: name !== undefined ? name : moment(), ImageID: erasureID }));
                snackActions.snackBar({
                    message: `${error && error.message ? error.message : translations['download_fail'] || 'Download failed.'}`,
                    options: {
                        variant: 'error'
                    }
                });
            }
        });
    }
}

export const exportData = (params) => {
    return async _dispatch => {
        try {
            const token = localStorage.getItem('SESSION');
            const filename = `securaze_${moment().valueOf()}.${params.fileType}`;

            const objectURL = `${config.backend_domain}:${config.backend_port}/${params.route}/export-${params.fileType}?Visibility=${params.Visibility}&Type=${params.Type}&ActiveCustomerID=${params.ActiveCustomerID}&Columns=${params.Columns}&Token=${token}`;

            const response = await fetch(objectURL, {
                method: 'POST',
                headers: {
                    mode: 'no-cors', // no-cors, *cors, same-origin
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ download: false })
            });
            if (response.status === 200) {
                const downloadElement = document.createElement('a');
                downloadElement.href = objectURL;
                downloadElement.download = filename;
                downloadElement.click();
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    }
}

export const downloadMedia = (MediaID, isSignature) => {
    const name = MediaID.split('.')[0];

    return async dispatch => {
        snackActions.snackBar({
            message: `Download started`,
            options: {
                variant: 'info'
            }
        });
        let path = isSignature ? `${config.backend_domain}:${config.backend_port}/static-signature/${MediaID}` : `${config.backend_domain}:${config.backend_port}/static-media/${MediaID}`;

        return fetch(path, {
            method: "GET",
        }).then(async response => {
            try {
                if (response.status === 200) {
                    const reader = response.body.getReader();
                    const contentLength = +response.headers.get('fileSize');
                    let receivedLength = 0;
                    let chunks = [];
                    while (true) {
                        const { done, value } = await reader.read();

                        if (done) {
                            break;
                        }
                        chunks.push(value);
                        receivedLength += value.length;
                        dispatch(updateDownloadProgress({ downloadProgress: Math.floor(receivedLength / contentLength * 100), maxSize: Math.floor(contentLength / 1048576), currentSize: Math.floor(receivedLength / 1048576), snackBar: (contentLength / 1048576 === receivedLength / 1048576), name: name !== undefined ? name : moment(), ImageID: MediaID }));

                    }
                    snackActions.snackBar({
                        message: `Download success`,
                        options: {
                            variant: 'success'
                        }
                    });
                    dispatch(updateDownloadProgress({ downloadProgress: 0, maxSize: 0, currentSize: 0, snackBar: false, name: name !== undefined ? name : moment(), ImageID: MediaID }));

                    return new Blob(chunks);
                }
                return null;
            } catch (error) {
                dispatch(updateDownloadProgress({ downloadProgress: 0, maxSize: 0, currentSize: 0, snackBar: false, name: name !== undefined ? name : moment(), ImageID: MediaID }));
                snackActions.snackBar({
                    message: `${error && error.message ? error.message : 'Download failed '}`,
                    options: {
                        variant: 'error'
                    }
                });
            }
        });
    }
}


export const downloadError = (ErrorLogID, id, name) => {
    let token = localStorage.getItem('SESSION');

    return async dispatch => {
        snackActions.snackBar({
            message: `Download started`,
            options: {
                variant: 'info'
            }
        });

        return fetch(`${config.backend_domain}:${config.backend_port}/error_logs/download?ErrorLogID=${ErrorLogID}&ActiveCustomerID=${id}&Token=${token}`, {
            method: "GET",
        }).then(async response => {
            try {

                if (response.status === 200) {
                    const reader = response.body.getReader();
                    const contentLength = +response.headers.get('fileSize');
                    let receivedLength = 0;
                    let chunks = [];
                    while (true) {
                        const { done, value } = await reader.read();

                        if (done) {
                            break;
                        }
                        chunks.push(value);
                        receivedLength += value.length;
                        dispatch(updateDownloadProgress({ downloadProgress: Math.floor(receivedLength / contentLength * 100), maxSize: Math.floor(contentLength / 1048576), currentSize: Math.floor(receivedLength / 1048576), snackBar: (contentLength / 1048576 === receivedLength / 1048576), name: name !== undefined ? name : moment(), ImageID: ErrorLogID }));

                    }
                    snackActions.snackBar({
                        message: `Download success`,
                        options: {
                            variant: 'success'
                        }
                    });
                    dispatch(updateDownloadProgress({ downloadProgress: 0, maxSize: 0, currentSize: 0, snackBar: false, name: name !== undefined ? name : moment(), ImageID: ErrorLogID }));

                    return { blob: new Blob(chunks), fileName: response.headers.get('filename') };
                }
                return null;
            } catch (error) {
                dispatch(updateDownloadProgress({ downloadProgress: 0, maxSize: 0, currentSize: 0, snackBar: false, name: name !== undefined ? name : moment(), ImageID: ErrorLogID }));
                snackActions.snackBar({
                    message: `${error && error.message ? error.message : 'Download failed '}`,
                    options: {
                        variant: 'error'
                    }
                });
            }
        });
    }
}

export const downloadStatistic = (ActiveCustomerID, filePath, fileName) => {
    let token = localStorage.getItem('SESSION');
    return async dispatch => {
        snackActions.snackBar({
            message: `Download starting...`,
            options: {
                variant: 'info'
            }
        });

        return fetch(`${config.backend_domain}:${config.backend_port}/statistics/download-report?FilePath=${filePath}&FileName=${fileName}&ActiveCustomerID=${ActiveCustomerID}&Token=${token}`, {
            method: "GET",
        }).then(async response => {
            try {

                if (response.status === 200) {
                    const reader = response.body.getReader();
                    // const contentLength = +response.headers.get('fileSize');
                    // let receivedLength = 0;
                    let chunks = [];
                    while (true) {
                        const { done, value } = await reader.read();

                        if (done) {
                            break;
                        }
                        chunks.push(value);
                        // receivedLength += value.length;

                        // dispatch(updateDownloadProgress({ downloadProgress: Math.floor(receivedLength / contentLength * 100), maxSize: Math.floor(contentLength / 1048576), currentSize: Math.floor(receivedLength / 1048576), snackBar: contentLength / 1048576 === receivedLength / 1048576, name: name !== undefined ? name : moment(), ImageID: erasureID }));

                    }
                    snackActions.snackBar({
                        message: `Download successful.`,
                        options: {
                            variant: 'success'
                        }
                    });
                    // dispatch(updateDownloadProgress({ downloadProgress: 0, maxSize: 0, currentSize: 0, snackBar: false, name: name !== undefined ? name : moment(), ImageID: erasureID }));

                    return new Blob(chunks);
                }
                return null;
            } catch (error) {
                // dispatch(updateDownloadProgress({ downloadProgress: 0, maxSize: 0, currentSize: 0, snackBar: false, name: name !== undefined ? name : moment(), ImageID: erasureID }));
                snackActions.snackBar({
                    message: `${error && error.message ? error.message : 'Download failed.'}`,
                    options: {
                        variant: 'error'
                    }
                });
            }
        });
    }
}